import React from "react";
import { styled } from "@mui/material/styles";
import {
    Box,
    Grid,
    GridProps,
    IconButton,
    InternalStandardProps,
} from "@mui/material";
import { QueueItems } from "./QueueItems";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SortableHandle } from "@lumel/react-sortable-hoc";
import { AppDownloadingIcons } from "JS/React/Components/Icon/AppDownloadingIcons";

const ContentWrapper = styled(Grid)({
    display: "flex",
    width: "100%",
});

const SortWrapper = styled(Box)({
    display: "flex",
    alignItems: "center",
    width: "80%",
});

const EditWrapper = styled(Box)({
    display: "flex",
    alignItems: "center",
    width: "90%",
});

const QueueWrapper = styled(Box)({
    display: "flex",
    width: "100%",
});

const IconsWrapper = styled(Box)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "10%",
});

const DragHandleBox = styled(Box)(({ theme }) => ({
    cursor: "grab",
    touchAction: "none",
    "&:active": {
        cursor: "grabbing",
    },
}));

const DragIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    fontSize: "20px",
    cursor: "pointer",
    color: theme.palette.common.black,
}));

const DragHandle = SortableHandle(
    ({ ref }: { ref?: React.Ref<HTMLDivElement> }) => (
        <DragHandleBox ref={ref} onClick={(e) => e.stopPropagation()}>
            <DragIcon icon={["fas", "bars"]} />
        </DragHandleBox>
    ),
);

export interface QueueProps extends InternalStandardProps<GridProps> {
    isDownloading: boolean;
    isShowProgress: boolean;
    isDisableControls: boolean;
    isEdit: boolean;
    type: string;
    name: string;
    nid: string;
    isSortable: boolean;
    handleDeleteItem: (nid: string) => void;
}

export const Queue = (props: QueueProps) => {
    const {
        className,
        isShowProgress,
        isDownloading,
        type,
        isEdit,
        name,
        nid,
        isSortable,
        handleDeleteItem,
        isDisableControls,
        ...rest
    } = props;

    const getContentWrapper = () => {
        if (isEdit) {
            return isSortable ? SortWrapper : EditWrapper;
        }
        return QueueWrapper;
    };

    const WrapperComponent = getContentWrapper();

    return (
        <ContentWrapper {...rest}>
            {isEdit && isSortable && (
                <IconsWrapper>
                    <DragHandle />
                </IconsWrapper>
            )}
            <WrapperComponent>
                <QueueItems
                    isShowProgress={isShowProgress}
                    isDownloading={isDownloading}
                    contentType={type}
                    contentTitle={name}
                />
            </WrapperComponent>

            {isEdit && (
                <>
                    <IconsWrapper>
                        <IconButton>
                            <AppDownloadingIcons
                                iconType="trash"
                                onClick={() => handleDeleteItem(nid)}
                            />
                        </IconButton>
                    </IconsWrapper>
                </>
            )}
        </ContentWrapper>
    );
};
